module.exports = __webpack_public_path__ + "static/media/Insider_Logo_Fundo_Claro.9b5a757e.png";